import { ProposalSubmissionApiTypes } from '@mono/proto-clients';
import { z } from 'zod';
export const draftSchema = z.object({
    pricingVersionId: z.string(),
    staffingVersionId: z.string(),
    solicitationVersionId: z.string(),
    files: z.array(z.object({
        artifactId: z.string(),
        artifactVersion: z.number().int().positive()
    })),
    sectionVersionIds: z.array(z.string()),
    submittedAt: z.string(),
    submittedTimezone: z.string(),
    submittedBy: z.string(),
    method: z.string(),
    recipient: z.string(),
    receiptReference: z.string(),
    notes: z.string(),
    supersedesId: z.string()
});
export const emptyDraft = {
    pricingVersionId: '',
    staffingVersionId: '',
    solicitationVersionId: '',
    files: [],
    sectionVersionIds: [],
    submittedAt: '',
    submittedTimezone: '',
    submittedBy: '',
    method: '',
    recipient: '',
    receiptReference: '',
    notes: '',
    supersedesId: ''
};
const savedSchema = z.object({
    draft: draftSchema,
    pending: z.string().nullable()
});
export function draftKey(account, projectId) {
    return `proposal-submission:${JSON.stringify([
        account,
        projectId
    ])}`;
}
export function restoreDraft(key, projectId) {
    const raw = sessionStorage.getItem(key);
    if (!raw) return {
        draft: emptyDraft,
        pending: null
    };
    const saved = savedSchema.parse(JSON.parse(raw));
    if (saved.pending) {
        const request = ProposalSubmissionApiTypes.RecordProposalSubmissionRequest.fromJsonString(saved.pending);
        if (request.projectId !== projectId || !request.submission?.requestId) {
            throw new Error('Saved submission does not match this Proposal.');
        }
    }
    return saved;
}
export function persistDraft(key, draft, pending) {
    sessionStorage.setItem(key, JSON.stringify({
        draft,
        pending
    }));
}
export function validSubmissionTime(value, timezone) {
    const parts = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.\d{1,3})?(Z|[+-]\d{2}:\d{2})$/.exec(value);
    if (!parts || !Number.isFinite(Date.parse(value))) return false;
    const [, year, month, day, hour, minute, second, offset] = parts;
    const daysInMonth = new Date(Date.UTC(Number(year), Number(month), 0)).getUTCDate();
    if (Number(month) < 1 || Number(month) > 12 || Number(day) < 1 || Number(day) > daysInMonth || Number(hour) > 23 || Number(minute) > 59 || Number(second) > 59) return false;
    if (offset !== 'Z' && (Number(offset.slice(1, 3)) > 23 || Number(offset.slice(4)) > 59)) return false;
    try {
        new Intl.DateTimeFormat('en', {
            timeZone: timezone
        }).format();
        return timezone.trim().length > 0;
    } catch  {
        return false;
    }
}
